module.exports = __webpack_public_path__ + "img/hekkfjell-vol2.d2497b7f.jpg";